export default "__VITE_ASSET__dd519145__"